import React from 'react';
import { useEffect, useState } from 'react';
import PropTypes, { func } from 'prop-types';
import { Checkbox, FormControlLabel } from '@material-ui/core';
import styled from 'styled-components';
import RoleListBox from '../../../RoleListBox/RoleListBox';
import EntitlementListBox from '../../../EntitlementListBox';
import CopyIcon from '../../../shared/CopyIcon';
import { CopyDataToClipBoard } from '../../../../../util/CommonUtils';
import { getActivationKey } from '../../../../../actions/activationKeyActions';
import IconCheckboxEmpty from '../../../../autocode/ACShared/IconCheckBoxEmpty';
import IconCheckboxCheck from '../../../../autocode/ACShared/IconCheckBoxCheck';

const CheckLabel = styled.div`
  font-weight: 'normal';
  font-size: '16px';
  line-height: '15px';
  color: #333333;
  width: 100%;
  word-break: break-word;
  user-select: none;
`;

const GenerateActivationKey = ({
  accountDetail,
  availableRoles,
  availableEntitlements,
  activeRoles,
  activeEntitlements,
  setActiveRoles,
  setActiveEntitlements,
  generateKey,
  isDataChanged,
  error,
  successMessage,
  activationKey,
  handleOnChange,
  successIsAddSubscriptions,
}) => {
  const [checkBoxSelected, setCheckBoxSelected] = useState(false);
  const updateSelectedRoles = activeRoles => {
    setActiveRoles(activeRoles);
  };
  const updateSelectedEntitlement = activeEnt => {
    setActiveEntitlements(activeEnt);
  };
  const isRoleAndEntSelected = () => {
    return activeRoles.length && activeEntitlements.length;
  };

  useEffect(() => {
    if (successIsAddSubscriptions && successIsAddSubscriptions !== '') {
      if (successIsAddSubscriptions === 'Y') {
        setCheckBoxSelected(true);
      } else {
        setCheckBoxSelected(false);
      }
    }
  }, [successIsAddSubscriptions]);

  return (
    <div className="activation-view accounts-role">
      {error && (
        <span className="error-message">
          {error}{' '}
          {activationKey && `********************************${activationKey}`}
          {activationKey && (
            <button
              type="button"
              onClick={() =>
                CopyDataToClipBoard(
                  { publicId: accountDetail.publicId, activationKey },
                  true,
                  getActivationKey
                )
              }
              className="table-cell-button activationKey-copy"
            >
              <CopyIcon />
            </button>
          )}
        </span>
      )}
      {successMessage && (
        <span className="success-message">
          {successMessage}{' '}
          {activationKey && `********************************${activationKey}`}
          {activationKey && (
            <button
              type="button"
              onClick={() =>
                CopyDataToClipBoard(
                  { publicId: accountDetail.publicId, activationKey },
                  true,
                  getActivationKey
                )
              }
              className="table-cell-button activationKey-copy"
            >
              <CopyIcon />
            </button>
          )}
        </span>
      )}
      <div className="accounts-details-card-header">
        <div className="role-title">
          <h4>Generate Activation Key</h4>
        </div>
        <div style={{ width: '45rem' }}>
          <FormControlLabel
            style={{ float: 'right' }}
            control={
              <Checkbox
                data-test="AutocodeCheckBox"
                className="ac--checkbox"
                checked={checkBoxSelected}
                onChange={event => handleOnChange(event)}
                icon={<IconCheckboxEmpty stroke="#6F6F6F" />}
                checkedIcon={
                  <IconCheckboxCheck
                    fill="#DADADA"
                    stroke="#DADADA"
                    opacity="0"
                  />
                }
                color="primary"
                disabled={false}
              />
            }
            label={
              <CheckLabel>
                <span style={{ fontSize: '1.25rem' }}>
                  Update Key with latest subscription
                </span>
              </CheckLabel>
            }
          />
        </div>
        <div
          className="adduser-card-actions roles-actions"
          style={{ width: 'auto' }}
        >
          {' '}
          <button
            className="btn activationKeyBtn"
            disabled={!isRoleAndEntSelected() || isDataChanged}
            type="button"
            onClick={() => generateKey()}
          >
            <span>Generate Key</span>
          </button>
        </div>
      </div>
      <div className="activation-box">
        <div className="user-team-box">
          <RoleListBox
            roles={availableRoles}
            activeRoles={activeRoles}
            updateSelectedItems={updateSelectedRoles}
            clearUsers={false}
            activationKey
          />
        </div>
        <div className="user-entitlement-box">
          <EntitlementListBox
            entitlements={availableEntitlements}
            activeEntitlements={activeEntitlements}
            updateSelectedItems={updateSelectedEntitlement}
            clearUsers={false}
            activeAccountId={accountDetail.accountId}
            activationKey
          />
        </div>
      </div>
    </div>
  );
};
GenerateActivationKey.propTypes = {
  accountDetail: PropTypes.instanceOf(Object),
  availableRoles: PropTypes.arrayOf(PropTypes.object),
  availableEntitlements: PropTypes.arrayOf(PropTypes.object),
  activeRoles: PropTypes.arrayOf(PropTypes.object),
  activeEntitlements: PropTypes.arrayOf(PropTypes.object),
  setActiveRoles: PropTypes.func,
  setActiveEntitlements: PropTypes.func,
  generateKey: PropTypes.func,
  isDataChanged: PropTypes.bool,
  error: PropTypes.string,
  successMessage: PropTypes.string,
  handleOnChange: func,
  successIsAddSubscriptions: PropTypes.string,
  activationKey: PropTypes.string,
};
export default GenerateActivationKey;
